module.exports = __webpack_public_path__ + "img/xiaozi_huice.261da9b2.png";